module.exports = __webpack_public_path__ + "img/button_game_rock.bec4ae04.svg";